import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_TEACHER,
  GET_TEACHERS,
  GET_TEACHERS_DDL,
  GET_TEACHERS_BY_FILTER,
  ADD_TEACHER,
  ADD_TEACHERS_UPLOAD,
  UPDATE_TEACHER,
  DELETE_TEACHER,
} from '@/queries/modules/profile/teacher';

export async function getTeachers(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_TEACHERS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setTeachers', data.getTeachers);
      context.commit('setSuccess', null);
      return data.getTeachers
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getTeachersDdl(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_TEACHERS_DDL,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setTeachersDdl', data.getTeachers);
      context.commit('setSuccess', null);
      return data.getTeachers
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getTeachersByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_TEACHERS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setTeachers', data.getTeachersByFilter);
      context.commit('setSuccess', null);

      return data.getTeachersByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_TEACHER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setTeacher', data.getTeacher);
      context.commit('setSuccess', null);
      return data.getTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_TEACHER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const teachers = [...context.state.teachers];
      teachers.push(data.addTeacher);
      context.commit('setTeachers', teachers);
      context.commit('setSuccess', newItemSuccess(data.addTeacher.code));

      return data.addTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addTeachersUpload(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_TEACHERS_UPLOAD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addTeachersUpload.length));

      return data.addTeachersUpload
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_TEACHER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.teachers.findIndex(item => item.id === data.updateTeacher.id);
      const teachers = [
        ...context.state.teachers.slice(0, index),
        data.updateTeacher,
        ...context.state.teachers.slice(index + 1)
      ];
      context.commit('setTeachers', teachers);
      context.commit('setSuccess', updateItemSuccess(data.updateTeacher.code));

      return data.updateTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_TEACHER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.teachers.findIndex(item => item.id === data.deleteTeacher.id);
      const teachers = [
        ...context.state.teachers.slice(0, index),
        ...context.state.teachers.slice(index + 1)
      ];
      context.commit('setTeachers', teachers);
      context.commit('setSuccess', deleteItemSuccess(data.deleteTeacher.code));

      return data.deleteTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
